
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46path_935z1Qu7hFoAJqQ_z61jZb3w_Orj0ooo7CLzaJX9k78gEMeta } from "/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/mijn/[...path].vue?macro=true";
import { default as iban_45wijzigen8Bb0H2yTDsA4j_Jw_dpFw_ZvJFoRCX8T3H2MR3sNNSsMeta } from "/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/mijn/profiel/iban-wijzigen.vue?macro=true";
import { default as mijn2Dgw5ESZTB_45yZcjg9OE7XkiR8ny15znhCCHkrB1h7SQMeta } from "/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/mijn.vue?macro=true";
import { default as _91_46_46_46path_93aeDFYVV_45WkLArJeXE1A0OQdCZmVPwxpG3T6nAWchRXUMeta } from "/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/[...path].vue?macro=true";
import { default as _91customerId_93dnGcM2Q0oz7z0xtvGa4L6Sj9MAf0i3IJ9kSEoewdP7IMeta } from "/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/uitschrijven/[vertical]/[customerId].vue?macro=true";
export default [
  {
    name: "mijn",
    path: "/mijn",
    component: () => import("/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/mijn.vue"),
    children: [
  {
    name: "mijn-path",
    path: ":path(.*)*",
    component: () => import("/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/mijn/[...path].vue")
  },
  {
    name: "mijn-profiel-iban-wijzigen",
    path: "profiel/iban-wijzigen",
    component: () => import("/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/mijn/profiel/iban-wijzigen.vue")
  }
]
  },
  {
    name: "path",
    path: "/:path(.*)*",
    component: () => import("/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/[...path].vue")
  },
  {
    name: "uitschrijven-vertical-customerId",
    path: "/uitschrijven/:vertical()/:customerId()",
    component: () => import("/home/vsts/work/1/s/src/Nedwin.Portal.Frontend/pages/uitschrijven/[vertical]/[customerId].vue")
  }
]